export default {
  orange: '#FE8A00',
  lightred: '#ff6258',
  lightorange: '#f1592a',
  lighterorange: '#f6966f',
  accent: '#FFC107',
  whiteyellow: '#ffb63f',
  ligthgreen: '#a4dcbb',
  lightgreen2: '#d7ffe7',
  lightgreenstatus: '#74C13B',
  whiteblue: '#41a1f9',
  whitegray2: '#666666',
  fullgray: '#888888',
  graybrown: '#bcbcc4',
  slateGrey: '#626e72',
  brown: '#424242',
  darkgray: '#7C7C84',
  dark: '#000000',
  lightdark: '#1e2129',

  graywhite: '#dadada',
  whitegray: '#eeeeee',
  lightpink: '#ffeae4',
  lightgray: '#EFEFEF',
  ligth: '#f5f5f5',
  white: '#ffffff',
  black: '#000000',
  blue1: 'rgba(18, 126, 195, 0.1)',
  blue2: '#004E91',
  blue3: '#3288D8',
  blue16: 'rgba(18, 126, 195, 0.16)',
  blue24: 'rgba(18, 126, 195, 0.24)',
  blue: '#127ec3',
  hoverBlue: '#127ec3d9',
  yellow: '#FDBD04',
  yellow2: '#FFAF00',
  green: '#399F5A',
  red: '#F54055',
  bluestatus: '#158CAA',
  purple: '#776AC7',

  primaryblue: '#127ec3',
  primary: '#117EC3',
  primaryHover: '#45D7C1',
  primaryClick: '#21AC97',
  danger: '#FF5656',
  dangerHover: '#FF8484',
  dangerClick: '#EC4141',
  success: '#30C948',
  secondary: '#858585',
  secondaryHover: '#999999',
  secondaryClick: '#757575',

  gray: '#E5E5E5',
  dropdown: '#F3F6F9',
  disabled: '#F5F5F5',

  vividgreen: '#19D895',
  greenGradient: '#47C5B2',
  greenGradient2: '#009EA8',

  graphGradient: '#7EF0DF',
  graphGradient2: '#47C5B2',

  textBlack: '#333333',
  tabBlue: '#004E91',
  hoverLightBlue: 'rgba(17 126 195 / 10%)',
  formLabel: '#262626',

  holiday: '#556ee6',
  workOutside: '#47C5B2',
  busy: '#FF5656',
}
